var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.hasAccess == true && (!_vm.$store.getters.isImpersonation || _vm.isSilentLoginOnceCalled))?_c('div',{attrs:{"id":"nav"}},[_c('router-view')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }